exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-templates-project-template-jsx": () => import("./../../../src/templates/project-template.jsx" /* webpackChunkName: "component---src-templates-project-template-jsx" */),
  "component---src-templates-talk-template-jsx": () => import("./../../../src/templates/talk-template.jsx" /* webpackChunkName: "component---src-templates-talk-template-jsx" */)
}

